import React, { useCallback, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import {
  exportIndividualsToCSV,
  deleteAllIndividuals,
} from "common/services/individuals.service";
import ExportLoadingModal from "Components/Common/ExportLoadingModal";
import { toast } from "react-toastify";
import Permission from "Components/Common/Permission";
import IndividualsImportModal from "./IndividualsImportModal";

const Import = ({
  apiParams,
  fetchData,
}: {
  apiParams: any;
  fetchData?: () => void;
}) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isDeleteAllModalOpen, setIsDeleteAllModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [exporting, setExporting] = useState(false);
  const getCsvExport = useCallback(async () => {
    setExporting(true);

    await exportIndividualsToCSV({
      filters: apiParams.filters,
      sort: apiParams.sort,
    })
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Individuals_Export.csv");
        link.click();
        link.remove();
      })
      .catch((error: any) => {
        toast.error("An error occurred while exporting individuals");
      });

    setExporting(false);
  }, [apiParams]);

  const handleDeleteAll = useCallback(async () => {
    setIsDeleting(true);

    await deleteAllIndividuals({
      filters: apiParams.filters,
    })
      .then((response: any) => {
        toast.success("All individuals have been deleted successfully");
        // Refresh the page or data after successful deletion
        window.location.reload();
      })
      .catch((error: any) => {
        toast.error("An error occurred while deleting individuals");
      })
      .finally(() => {
        setIsDeleting(false);
        setIsDeleteAllModalOpen(false);
      });
  }, [apiParams]);

  return (
    <>
      <UncontrolledDropdown>
        <DropdownToggle
          tag="button"
          className="btn btn-light"
          id="dropdownMenuButton"
        >
          <i className="ri ri-more-fill"></i>
        </DropdownToggle>
        <DropdownMenu>
          <Permission resource="individual" action="import">
            <DropdownItem
              onClick={() => {
                setIsImportModalOpen(true);
              }}
            >
              <i className="ri ri-upload-2-line me-1"></i>
              Import
            </DropdownItem>
          </Permission>
          <Permission resource="individual" action="exportToCsv">
            <DropdownItem
              onClick={() => {
                getCsvExport();
              }}
            >
              <i className="ri ri-download-2-line me-1"></i>
              Export
            </DropdownItem>
          </Permission>
          <Permission resource="individual" action="clearAll">
            <DropdownItem
              onClick={() => {
                setIsDeleteAllModalOpen(true);
              }}
              className="text-danger"
            >
              <i className="ri ri-delete-bin-line me-1"></i>
              Delete All
            </DropdownItem>
          </Permission>
        </DropdownMenu>
      </UncontrolledDropdown>

      <IndividualsImportModal
        toggle={() => setIsImportModalOpen(!isImportModalOpen)}
        isOpen={isImportModalOpen}
        onImported={fetchData}
      />
      <ExportLoadingModal show={exporting} onCloseClick={() => {}} />

      {/* Delete All Confirmation Modal */}
      <Modal
        isOpen={isDeleteAllModalOpen}
        toggle={() => setIsDeleteAllModalOpen(!isDeleteAllModalOpen)}
        centered
      >
        <ModalHeader toggle={() => setIsDeleteAllModalOpen(false)}>
          Confirm Delete All
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete all individuals
          {apiParams.filters ? " matching the current filters" : ""}? This
          action cannot be undone.
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setIsDeleteAllModalOpen(false)}
            disabled={isDeleting}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            onClick={handleDeleteAll}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete All"}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Import;
